export default __webpack_public_path__ + "static/media/mi-dashboard.d3250e07.svg";